module.exports = __webpack_public_path__ + "static/img/1_2_1_4.118d9f43.jpg";